export default __webpack_public_path__ + "static/media/Kai.e7e15cf2.png";